import { Component } from 'react';

import CarrierPickupLocation from './carrierPickupLocation/CarrierPickupLocation';
import Charge from './charge/Charge';
import CustomerLoggedInPickup from './customer/CustomerLoggedInPickup';
import CustomerLoggedInShip from './customer/CustomerLoggedInShip';
import CustomerNotLoggedInPickup from './customer/CustomerNotLoggedInPickup';
import CustomerNotLoggedInShip from './customer/CustomerNotLoggedInShip';
import Payment from './payment/Payment';
import PaymentLoggedInPickupHostedPayment from './payment/PaymentLoggedInPickupHostedPayment';
import PaymentLoggedInPickupPayGate from './payment/PaymentLoggedInPickupPayGate';
import PaymentLoggedInShipHostedPayment from './payment/PaymentLoggedInShipHostedPayment';
import PaymentLoggedInShipPayGate from './payment/PaymentLoggedInShipPayGate';
import PaymentNotLoggedInPickupHostedPayment from './payment/PaymentNotLoggedInPickupHostedPayment';
import PaymentNotLoggedInPickupPayGate from './payment/PaymentNotLoggedInPickupPayGate';
import PaymentNotLoggedInShipHostedPayment from './payment/PaymentNotLoggedInShipHostedPayment';
import PaymentNotLoggedInShipPayGate from './payment/PaymentNotLoggedInShipPayGate';
import Shipping from './shipping/Shipping';

class EditStep extends Component {
  constructor(props) {
    super(props);
    const { cart } = props;
    this.state = {
      orderDeliveryMethod: (cart && cart.orderDeliveryMethod) || 'Ship'
    };
  }

  handlePickup = () => {
    this.setState({ orderDeliveryMethod: 'Pickup' });
  };

  handleShip = () => {
    this.setState({ orderDeliveryMethod: 'Ship' });
  };

  render() {
    const { step, onEdit, cart, customer, settings } = this.props;
    const { orderDeliveryMethod } = this.state;
    const { payment } = settings.data;
    switch (step) {
      case 'customer':
        if (orderDeliveryMethod === 'Ship') {
          if (customer && cart.customerId) {
            return (
              <CustomerLoggedInShip
                cart={cart}
                onEdit={onEdit}
                onPickup={this.handlePickup}
              />
            );
          }
          return (
            <CustomerNotLoggedInShip
              cart={cart}
              onEdit={onEdit}
              onPickup={this.handlePickup}
            />
          );
        }
        if (customer && cart.customerId) {
          return (
            <CustomerLoggedInPickup
              cart={cart}
              onEdit={onEdit}
              onShip={this.handleShip}
            />
          );
        }
        return (
          <CustomerNotLoggedInPickup
            cart={cart}
            onEdit={onEdit}
            onShip={this.handleShip}
          />
        );
      case 'carrierPickupLocation':
        return (
          <CarrierPickupLocation
            onEdit={onEdit}
            cart={cart}
            settings={settings}
          />
        );
      case 'shipping':
        return <Shipping onEdit={onEdit} cart={cart} settings={settings} />;
      case 'payment':
        if (payment.gateway === 'PayGateHosted') {
          if (orderDeliveryMethod === 'Ship') {
            if (customer && cart.customerId) {
              return <PaymentLoggedInShipHostedPayment onEdit={onEdit} />;
            }
            return <PaymentNotLoggedInShipHostedPayment onEdit={onEdit} />;
          }
          if (customer && cart.customerId) {
            return <PaymentLoggedInPickupHostedPayment onEdit={onEdit} />;
          }
          return <PaymentNotLoggedInPickupHostedPayment onEdit={onEdit} />;
        }
        if (payment.gateway === 'PayGate') {
          if (orderDeliveryMethod === 'Ship') {
            if (customer && cart.customerId) {
              return <PaymentLoggedInShipPayGate onEdit={onEdit} />;
            }
            return <PaymentNotLoggedInShipPayGate onEdit={onEdit} />;
          }
          if (customer && cart.customerId) {
            return <PaymentLoggedInPickupPayGate onEdit={onEdit} />;
          }
          return <PaymentNotLoggedInPickupPayGate onEdit={onEdit} />;
        }
        return <Payment customer={customer} onEdit={onEdit} />;

      case 'complete':
        return <Charge cart={cart} />;
      default:
        throw new Error('Invalid Step');
    }
  }
}

export default EditStep;
